export default __webpack_public_path__ + "static/media/lock.bf8643b0.svg";